export const preconfiguredColors = [
  "#027680",
  "#0bb4ff",
  "#ffa300",
  "#d0f400",
  "#e6d800",
  "#9b19f5",
  "#50e991",
  "#00bfa0",
  "#e60049",
  "#dc0ab4",
];
